










































































import { Vue, Component } from "vue-property-decorator";
import { lockModule } from "@/store/lock";
import { PersonInsert } from "@/../generated/iloq-api";
import PersonList from "@/components/PersonList.vue";

@Component({
  components: { PersonList }
})
export default class PersonCreate extends Vue {
  personCode = "";
  firstName = "";
  lastName = "";
  phone1 = "";
  address = "";
  companyName = "";
  zone = "";

  get zones() {
    return lockModule.zones;
  }

  fetchPersons() {
    lockModule.fetchPersons();
  }

  createPerson() {
    const person: PersonInsert = {
      FirstName: this.firstName,
      LastName: this.lastName,
      Phone1: this.phone1,
      PersonCode: this.personCode,
      Address: this.address,
      CompanyName: this.companyName,
      ContactInfo: "",
      Country: "",
      Description: "",
      eMail: "",
      EmploymentEndDate: "",
      ExternalCanEdit: true,
      ExternalPersonId: null,
      Phone2: "",
      Phone3: "",
      PostOffice: "",
      State: 0,
      WorkTitle: "",
      ZipCode: ""
    };
    lockModule
      .createPerson({ person, zoneId: this.zone })
      .then(() => {
        this.$emit("close");
        this.fetchPersons();
      })
      .catch(error => {
        console.log(error);
      });
  }
}
